/**
 * Created by minimus on 22.12.2014.
 */
(function($) {
  $(document).ready(function() {
    $('#tabs').ejTab({
      enablePersistence: true,
      headerPosition: "left"
    });

    const access = $('#access');
    const rs = $('#role-slider');
    const accVal = access.val();
    const upd = $('.updated');
    rs.ionRangeSlider({
      type: 'single',
      from: options.values.indexOf(accVal),
      values: [0,1,2,3,4],
      grid: true,
      force_edges: true,
      prettify_enabled: true,
      prettify: function(num) {
        return options.roles[num];
      },
      onChange: function(data) {
        access.val(options.values[data.from]);
        return false;
      }
    });

    if(upd.is(':visible')) upd.delay(3000).hide('blind', {direction:'vertical'}, 500);

    $('#addons-list').skitter({with_animations: ["cut", "paralell", "glassBlock", "swapBars"]});
  });
})(jQuery);
